import { createSlice } from "@reduxjs/toolkit";
import { addProductToCart } from "./cartSlice/actions/addProductToCart";
const initialState = {
    opened: false,
    interacted: false,
    lastAddedProductSku: "",
};
export const cartMini = createSlice({
    name: "cartMini",
    initialState,
    reducers: {
        open(state) {
            state.opened = true;
            state.interacted = true;
        },
        close(state) {
            state.opened = false;
            state.interacted = false;
        },
        interact(state) {
            state.interacted = true;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(addProductToCart.fulfilled, (state, action) => {
            state.opened = true;
            state.interacted = false;
            state.lastAddedProductSku = action.meta.arg.sku;
        });
    },
});
//# sourceMappingURL=cartMini.js.map